import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const SubtitleSettingsV1 = z.object({
  text: z.string(),
  style: z.string(),
})

export type TSubtitleSettingsV1 = z.infer<typeof SubtitleSettingsV1>

export const SubtitleElementV1 = z.object({
  id: z.string(),
  name: z.literal("subtitle"),
  settings: SubtitleSettingsV1,
  container: ContainerOptionsV1,
})

export type TSubtitleElementV1 = z.infer<typeof SubtitleElementV1>

// Latest ---------------------
export const SubtitleSettings = SubtitleSettingsV1
export type TSubtitleSettings = TSubtitleSettingsV1
export const SubtitleElement = SubtitleElementV1
export type TSubtitleElement = TSubtitleElementV1
